import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: "8px 12px",
        "&:last-child": {
            paddingBottom: "8px",
        },
    },
    title: {
        margin: 0,
        fontSize: 16,
        fontWeight: 600,
        lineHeight: 1.2,
        color: "rgba(0, 0, 0, 0.75)",
    },
    instructions: {
        margin: 0,
        paddingLeft: 18,
        fontSize: 14,
        lineHeight: 1.35,
        // If the instructions list grows, keep it visible without consuming too much space.
        maxHeight: 110,
        overflowY: "auto",
        '& li': {
            marginTop: 2,
        }
    }
}));

export default () => {
    const classes = useStyles();

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                <h3 className={classes.title}>Instructions:</h3>
                <ol className={classes.instructions}>
                    <li>Maximum of 10,000 records are allowed per file.</li>
                    <li>Only one file will be processed at once, others will be queued.</li>
                </ol>
            </CardContent>
        </Card>
    );
};

